export const millisecondsPerSecond = 1000;
export const millisecondsPerMinute = millisecondsPerSecond * 60;
export const MILLISECONDS_PER_HOUR = millisecondsPerMinute * 60;
export function getNowTime() {
    return new Date().getTime();
}
//# sourceMappingURL=time.js.map